// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Layout */
.invoice-page {
  display: flex;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f0f2f5;
  /* padding: 20px; */
  border-radius: 10px;
  flex-direction: row;
}

/* Form Styling */
.invoice-form {
  width: 30%; /* Reduced form width */
  padding: 20px;
  background-color: rgb(230, 241, 247);
  /* border-radius: 10px; */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  /* margin-right: 20px; */
  display: flex;
  flex-direction: column;
}

/* Fee Box Layouts */
.fee-section {
  margin-bottom: 10px; /* Less margin between sections */
  /* padding: 10px; */
  /* border-radius: 5px;  */
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
  /* background-color: #e8e8e8; */
  width: 100%; /* Reduced width for fee sections */
}
.abacus-fee{
  background-color: rgb(192, 237, 191);
}
.outstanding-fee{
  background-color: rgb(237, 204, 191);
}
.delivery-fee{
  background-color:rgb(191, 210, 237)
}
.bank-details{
  background-color:rgb(191, 237, 237)
}

.monthly-fee, .membership-fee, .abacus-fee, .outstanding-fee,.delivery-fee, .bank-details {
  margin-bottom: 8px; /* Less margin between these sections */
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}
.monthly-fee{
  background-color: rgb(216, 189, 237);
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}
/* Date Input Layout */
.date-inputs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.date-inputs .form-group {
  flex: 1 1 45%; /* Keep columns aligned */
}

/* Adjust Form Group Layout */
.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px; /* Reduced label font size */
  color: #333;
  margin-bottom: 5px;
}

/* Inputs and Dropdowns */
.invoice-page input[type="text"],
.invoice-page input[type="number"],
.invoice-page input[type="date"],
.invoice-page textarea,
.invoice-page select {
  width: 100%; 
  padding: 8px;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  font-size: 14px; /* Reduced font size */
  color: #333;
}

textarea {
  height: 70px; /* Reduced height of text area */
}

select {
  background-color: #fafafa;
}

/* Buttons */
button[type="submit"] {
  width: 70%; /* Decreased button width */
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px; /* Reduced font size */
  cursor: pointer;
  transition: background-color 0.3s;
}

button[type="submit"]:hover {
  background-color: #0056b3;
}

/* Invoice Display */
.invoice-display {
  width: 75%; /* Reduced display panel width */
  padding: 25px;
  background-color: #ffffff;
  /* border-radius: 10px; */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.invoiceLink:hover{
  color: #333;
}
.invoice-list-display {
  width: 70%; /* Reduced display panel width */
  padding: 25px;
  background-color: #ffffff;
  /* border-radius: 10px; */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.invoice-display h2, .invoice-list-display h2{
  /* font-size: 20px; Reduced heading size */
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 20px;
  color: rgb(59, 59, 59);
  font-family: Barlow;
  font-size: 36px;


    min-height: 45px;
    height: max-content;
    flex-grow: 0;
    flex-shrink: 0

}

.invoice-display p, 
.invoice-display table,
.invoice-list-display p,
.invoice-list-display table {
  margin-bottom: 10px;
  font-size: 15px; /* Slightly smaller text */
  color: #333;
}
.billed p{
  margin-bottom: 0;
  font-size: 16px;

}
.billed {
  margin-bottom: 20px;
}

.unpaid{
  font-weight: bold;
  color: red;

}
.invoice-display table,
.invoice-list-display table
{
  width: 100%;
  border-collapse: collapse;
}

.invoice-display table th,
.invoice-list-display table th,
.invoice-display table td,
.invoice-list-display table td
 {
  /* border: 1px solid #d1d1d1; */
  padding: 10px;
  text-align: left;
}

.invoice-display table th,
.invoice-list-display table  th {
  background-color: rgb(230, 230, 232);
  color: black;
}

.invoice-display table td,
.invoice-list-display table td {
  background-color: #f9f9f9;
}

.invoice-display ul,
.invoice-list-display ul {
  list-style-type: none;
  padding-left: 0;
}

.invoice-display ul li,
.invoice-list-display ul li {
  margin-bottom: 10px;
}

.invoice-display p.subtotal {
  font-weight: bold;
  font-size: 18px;
  color: #333;
}
.invoice-display .total {
  font-weight: bold;
  font-size: 20px;
  color: #333;
}
.grayedColor {
  font-weight:500;
  font-size: 16px;
  color: #333;
}
.membership-fee{
  background-color: rgb(237, 236, 191);
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}
.invoice-header{
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.invoice-header p{
  font-size: 16px;
  font-weight: bolder;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .invoice-page {
    flex-direction: column;
  }

  .invoice-form,
  .invoice-display {
    width: 100%;
    margin-right: 0;
  }

  .fee-section .form-group {
    flex-direction: column;
    align-items: flex-start;
  }

  .fee-section input {
    width: 100%;
    margin-top: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/MyFees/StudentFee.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,UAAU,EAAE,uBAAuB;EACnC,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB,EAAE,iCAAiC;EACtD,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,+BAA+B;EAC/B,WAAW,EAAE,mCAAmC;AAClD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE;AACF;AACA;EACE;AACF;;AAEA;EACE,kBAAkB,EAAE,uCAAuC;EAC3D,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa,EAAE,yBAAyB;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe,EAAE,4BAA4B;EAC7C,WAAW;EACX,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;;;;;EAKE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe,EAAE,sBAAsB;EACvC,WAAW;AACb;;AAEA;EACE,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,UAAU,EAAE,2BAA2B;EACvC,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe,EAAE,sBAAsB;EACvC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,UAAU,EAAE,gCAAgC;EAC5C,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU,EAAE,gCAAgC;EAC5C,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;;;IAGb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ;;AAEJ;;AAEA;;;;EAIE,mBAAmB;EACnB,eAAe,EAAE,0BAA0B;EAC3C,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;;AAEjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,UAAU;;AAEZ;AACA;;;EAGE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;;;EAKE,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* General Layout */\n.invoice-page {\n  display: flex;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f0f2f5;\n  /* padding: 20px; */\n  border-radius: 10px;\n  flex-direction: row;\n}\n\n/* Form Styling */\n.invoice-form {\n  width: 30%; /* Reduced form width */\n  padding: 20px;\n  background-color: rgb(230, 241, 247);\n  /* border-radius: 10px; */\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  /* margin-right: 20px; */\n  display: flex;\n  flex-direction: column;\n}\n\n/* Fee Box Layouts */\n.fee-section {\n  margin-bottom: 10px; /* Less margin between sections */\n  /* padding: 10px; */\n  /* border-radius: 5px;  */\n  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */\n  /* background-color: #e8e8e8; */\n  width: 100%; /* Reduced width for fee sections */\n}\n.abacus-fee{\n  background-color: rgb(192, 237, 191);\n}\n.outstanding-fee{\n  background-color: rgb(237, 204, 191);\n}\n.delivery-fee{\n  background-color:rgb(191, 210, 237)\n}\n.bank-details{\n  background-color:rgb(191, 237, 237)\n}\n\n.monthly-fee, .membership-fee, .abacus-fee, .outstanding-fee,.delivery-fee, .bank-details {\n  margin-bottom: 8px; /* Less margin between these sections */\n  padding: 10px;\n  border-radius: 10px;\n  width: 100%;\n}\n.monthly-fee{\n  background-color: rgb(216, 189, 237);\n  padding: 10px;\n  border-radius: 10px;\n  width: 100%;\n}\n/* Date Input Layout */\n.date-inputs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.date-inputs .form-group {\n  flex: 1 1 45%; /* Keep columns aligned */\n}\n\n/* Adjust Form Group Layout */\n.form-group {\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\nlabel {\n  font-size: 14px; /* Reduced label font size */\n  color: #333;\n  margin-bottom: 5px;\n}\n\n/* Inputs and Dropdowns */\n.invoice-page input[type=\"text\"],\n.invoice-page input[type=\"number\"],\n.invoice-page input[type=\"date\"],\n.invoice-page textarea,\n.invoice-page select {\n  width: 100%; \n  padding: 8px;\n  border: 1px solid #d1d1d1;\n  border-radius: 5px;\n  font-size: 14px; /* Reduced font size */\n  color: #333;\n}\n\ntextarea {\n  height: 70px; /* Reduced height of text area */\n}\n\nselect {\n  background-color: #fafafa;\n}\n\n/* Buttons */\nbutton[type=\"submit\"] {\n  width: 70%; /* Decreased button width */\n  padding: 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 14px; /* Reduced font size */\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\nbutton[type=\"submit\"]:hover {\n  background-color: #0056b3;\n}\n\n/* Invoice Display */\n.invoice-display {\n  width: 75%; /* Reduced display panel width */\n  padding: 25px;\n  background-color: #ffffff;\n  /* border-radius: 10px; */\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n.invoiceLink:hover{\n  color: #333;\n}\n.invoice-list-display {\n  width: 70%; /* Reduced display panel width */\n  padding: 25px;\n  background-color: #ffffff;\n  /* border-radius: 10px; */\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.invoice-display h2, .invoice-list-display h2{\n  /* font-size: 20px; Reduced heading size */\n  font-weight: bold;\n  line-height: 1.3;\n  margin-bottom: 20px;\n  color: rgb(59, 59, 59);\n  font-family: Barlow;\n  font-size: 36px;\n\n\n    min-height: 45px;\n    height: max-content;\n    flex-grow: 0;\n    flex-shrink: 0\n\n}\n\n.invoice-display p, \n.invoice-display table,\n.invoice-list-display p,\n.invoice-list-display table {\n  margin-bottom: 10px;\n  font-size: 15px; /* Slightly smaller text */\n  color: #333;\n}\n.billed p{\n  margin-bottom: 0;\n  font-size: 16px;\n\n}\n.billed {\n  margin-bottom: 20px;\n}\n\n.unpaid{\n  font-weight: bold;\n  color: red;\n\n}\n.invoice-display table,\n.invoice-list-display table\n{\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.invoice-display table th,\n.invoice-list-display table th,\n.invoice-display table td,\n.invoice-list-display table td\n {\n  /* border: 1px solid #d1d1d1; */\n  padding: 10px;\n  text-align: left;\n}\n\n.invoice-display table th,\n.invoice-list-display table  th {\n  background-color: rgb(230, 230, 232);\n  color: black;\n}\n\n.invoice-display table td,\n.invoice-list-display table td {\n  background-color: #f9f9f9;\n}\n\n.invoice-display ul,\n.invoice-list-display ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.invoice-display ul li,\n.invoice-list-display ul li {\n  margin-bottom: 10px;\n}\n\n.invoice-display p.subtotal {\n  font-weight: bold;\n  font-size: 18px;\n  color: #333;\n}\n.invoice-display .total {\n  font-weight: bold;\n  font-size: 20px;\n  color: #333;\n}\n.grayedColor {\n  font-weight:500;\n  font-size: 16px;\n  color: #333;\n}\n.membership-fee{\n  background-color: rgb(237, 236, 191);\n  padding: 10px;\n  border-radius: 10px;\n  width: 100%;\n}\n.invoice-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n}\n.invoice-header p{\n  font-size: 16px;\n  font-weight: bolder;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .invoice-page {\n    flex-direction: column;\n  }\n\n  .invoice-form,\n  .invoice-display {\n    width: 100%;\n    margin-right: 0;\n  }\n\n  .fee-section .form-group {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .fee-section input {\n    width: 100%;\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
